import { Link } from 'react-router-dom';

import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  showWordmark?: boolean;
  asLink?: boolean;
}

export function LogoMark({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'brand-mark relative grid size-9 shrink-0 place-items-center rounded-[11px] shadow-[0_6px_20px_-8px_var(--glow),0_1px_0_0_rgba(255,255,255,0.35)_inset]',
        className,
      )}
      aria-hidden="true"
    >
      <svg viewBox="0 0 32 32" className="size-[22px]" fill="none">
        <path
          d="M7.5 23.5C12 13.5 19 12 24.5 9.5"
          stroke="#05130e"
          strokeWidth="2.6"
          strokeLinecap="round"
        />
        <circle cx="7.6" cy="23.4" r="2.5" fill="#05130e" />
        <circle cx="24.6" cy="9.4" r="2.5" fill="#05130e" />
        <circle cx="16.3" cy="16.6" r="1.15" fill="#05130e" opacity="0.55" />
      </svg>
    </span>
  );
}

export function Logo({ className, showWordmark = true, asLink = true }: LogoProps) {
  const content = (
    <>
      <LogoMark />
      {showWordmark ? (
        <span className="flex flex-col leading-none">
          <span className="text-[17px] font-semibold tracking-[-0.035em]">
            Flow<span className="text-foreground/55">Share</span>
          </span>
          <span className="mt-1 hidden text-[9px] uppercase tracking-[0.22em] text-muted-foreground/70 sm:block">
            Direct transfer
          </span>
        </span>
      ) : null}
    </>
  );

  const classes = cn('inline-flex items-center gap-2.5 rounded-lg', className);

  if (!asLink) return <div className={classes}>{content}</div>;

  return (
    <Link to="/" className={classes} aria-label="FlowShare home">
      {content}
    </Link>
  );
}
